export const PAGE_WINDOW_SIZE = 10;

export const isSerialField = (field) => {
  const name = String(field || '').toLowerCase();
  return name === 'serial' || name === 'serial_number' || name === 'asset_serial' || name === 'device_serial';
};

export const getColumnWidthClass = (field) => {
  const name = String(field || '').toLowerCase();
  if (isSerialField(name)) return 'col-serial';
  if (name === 'version') return 'col-version';
  if (name === 'name') return 'col-name';
  return '';
};

export const orderSoftwareColumns = (columns) => {
  const rest = [];
  const serialColumns = [];

  columns.forEach((column) => {
    if (isSerialField(column.field)) {
      serialColumns.push(column);
    } else {
      rest.push(column);
    }
  });

  return [...rest, ...serialColumns];
};

export const getSerialMenuPosition = (rect, viewportWidth) => ({
  top: rect.bottom + 4,
  right: Math.max(8, viewportWidth - rect.right)
});

export const getPageWindow = (currentPage, totalPages, windowSize = PAGE_WINDOW_SIZE) => {
  if (totalPages <= 0) {
    return { pages: [], hasMore: false, nextWindowPage: null };
  }

  const windowStart = Math.floor((currentPage - 1) / windowSize) * windowSize + 1;
  const windowEnd = Math.min(windowStart + windowSize - 1, totalPages);
  const pages = [];
  for (let page = windowStart; page <= windowEnd; page += 1) {
    pages.push(page);
  }

  const hasMore = windowEnd < totalPages;
  return {
    pages,
    hasMore,
    nextWindowPage: hasMore ? windowEnd + 1 : null
  };
};
